import { Filter } from "../../../types/filter";

import {
  Prefix,
  getNonEmptyUniqueSortedOptions,
  handlePrefix,
  isActiveFilter,
  stringOptionFactory,
} from "../utils";

export type ConsigneeZipQueryParam = "consigneeZip";
export type SomethingWithConsigneeZip = {
  consignee?: {
    zipCode?: string;
  };
  delivery?: {
    zipCode?: string;
  };
};

export const getDeliveryZipFilter = (
  data: SomethingWithConsigneeZip[],
  prefix?: Prefix
): Filter => ({
  label: "Delivery Zip",
  queryParam: handlePrefix("consigneeZip", prefix),
  options: getNonEmptyUniqueSortedOptions(
    data.map((d) => stringOptionFactory(d.delivery?.zipCode))
  ),
});

export const filterConsigneeZip = <T extends SomethingWithConsigneeZip>(
  data: T[],
  filters?: string[]
): T[] =>
  isActiveFilter(filters)
    ? data.filter(({ delivery }) => filters.includes(delivery?.zipCode || ""))
    : data;
